
import { RecordGroupsAssignedComponent } from './record-groups-assigned/record-groups-assigned.component';
import { RecordGroupsModalComponent } from './record-groups-modal/record-groups-modal.component';
const RecordGroupModule =
  angular.module('topbroker.recordGroup', [])
    .component('recordGroupsAssigned', RecordGroupsAssignedComponent)
    .component('recordGroupsModal', RecordGroupsModalComponent)
    .name;

export default RecordGroupModule;
